<template>
  <bulma-autocomplete id="phone-no-autocomplete"
    v-model="innerValue"
    :data="items"
    field="phoneNo"
    :class="[
      'phone-no-autocomplete',
      classProp
    ]"
    :value="innerValue"
    @input="getCustomerInsurerPhoneNo"
    @select="select"
    :keep-first="true"
    placeholder="Search name/mobile"
    :expanded="true">
    <template slot-scope="props">
      <div v-if="props.option.isGroupHeader"
        class="is-flex is-justify-content-space-between is-align-items-center has-background-light custom-header">
        <div
          class="is-size-8 has-text-weight-bold ">
          {{ props.option.groupName }}
        </div>
      </div>
      <div v-if="!props.option.isGroupHeader"
        class="is-flex is-justify-content-space-between is-align-items-center">
        <div>
          <strong>{{ props.option.phoneNo }}</strong>
          <span v-if="props.option.fullName"> - {{ props.option.fullName }}</span>
        </div>
        <div
          class="is-pulled-right">
          <span
            class="tag"
            :class="{
              'is-success': props.option.groupName === 'Customer',
              'is-info': props.option.groupName === 'Insurer'
            }"
            v-if="props.option.groupName"
          >
            {{ props.option.groupName }}
          </span>
        </div>
      </div>
    </template>
  </bulma-autocomplete>
</template>

<script>
import { BulmaAutocomplete } from '@/components/BulmaAutocomplete'
import { SmsService } from '@/services'
import _debounce from 'lodash.debounce'

export default {
  name: 'PhoneNoAutocomplete',
  components: {
    BulmaAutocomplete
  },
  mixins: [],
  props: {
    value: {
      type: String,
      default: ''
    },
    quoteId: {
      type: String,
      default: ''
    },
    classProp: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      items: [],
      innerValue: ''
    }
  },
  computed: {},
  watch: {
    innerValue(newVal, oldVal) {
      this.$emit('input', newVal)
    },
    value(newVal, oldVal) {
      this.innerValue = newVal
      this.$emit('input', newVal)
    }
  },
  created() {
    // console.log('created', this.value)
    // this.innerValue = this.value
    this.getCustomerInsurerPhoneNo()
  },
  mounted() {
    console.log('mounted', this.value)

  },
  beforeDestroy() {},
  methods: {
    groupWithHeaders(items) {
      const grouped = {}

      // Group items by groupName
      items.forEach(item => {
        const group = item.isInQuote
        if (!grouped[group]) {
          grouped[group] = []
        }
        grouped[group].push(item)
      })

      // Create final array with headers
      const final = []
      const groupOrder = [1, 0] // Optional: control display order

      groupOrder.forEach(group => {
        if (grouped[group]) {
          final.push({
            isGroupHeader: true,
            groupName: (group == 1)? 'In Quote': 'Out of Quote'
          })
          final.push(...grouped[group])
        }
      })
      return final
    },
    getCustomerInsurerPhoneNo: _debounce(async function (query) {
      if (query) {
        var contacts = await SmsService.getCustomersInsurersdetails(this.quoteId, query)
        this.items = this.groupWithHeaders(contacts)

        this.$nextTick(() => {
          const items = document.querySelectorAll('.phone-no-autocomplete .dropdown-item')
          items.forEach(link => {
            // link.classList.remove('is-disabled')
            link.classList.remove('is-hovered')
            link.removeAttribute('style')           // prevent clicks
            const hasCustomHeader = link.querySelector('.custom-header') !== null
            if (hasCustomHeader) {
              link.removeAttribute('href')                // removes link
              // link.classList.add('is-disabled')           // add styling class
              link.classList.add('is-hovered')
              link.style.pointerEvents = 'none'           // prevent clicks
              link.style.color = 'gray'                   // visual cue
            }
          })
        })
      } else {
        this.items = []
      }

    }, 100),
    keepOnlyDigits(str) {
      return str.replace(/\D/g, '') // keeps only digits
    },
    select(selectedItem) {
      if(!selectedItem || selectedItem.isGroupHeader)
        return
      if (selectedItem) {
        selectedItem.phoneNo = this.keepOnlyDigits(selectedItem.phoneNo)
        this.$emit('select', selectedItem)
      }
    }
  },

  beforeRouteEnter(to, from, next) {
    next()
  },
  beforeRouteLeave(to, from, next) {
    next()
  }
}
</script>

<style lang="scss" scoped>
.alpha-code-tag {
  font-size: 0.55rem;
  &.alpha-code-tag:not(:last-child) {
    margin-right: 0.15rem;
  }
  &.alpha-code-tag:not(body) {
    padding-left: 0.2rem;
    padding-right: 0.2rem;
  }

}

.custom-header {
    border-bottom: solid 1px  #d4d3d3 !important;
    color: d4d3d3 !important;
    font-size: 0.8rem !important;
    font-weight: bold !important;
  }
</style>
